// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"7a5eeb2b","980":"413d7281"}[chunkId] + ".css";
};